// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3sh8X","header":"ReportDetails_header__VId7U","title":"ReportDetails_title__3jVph","left":"ReportDetails_left__RDBko"};